import React from 'react';
import {Section,SectionHeader} from '../ui/Section';

export const Enhancements=()=> {
const enhancements=[
  {title: "Glass Barware", price: "$3/person"},
  {title: "Solid Silver or Gold Charger Plates", price: "$2/person"},
  {title: "Silver or Gold Glass Bead Chargers", price: "$7/person"},
  {title: "Chiavari Chairs (Gold, Silver, Clear, Black, White)", price: "$10/person"},
  {title: "Napkin Rings", price: "$1–$2/person"},
  {title: "Stand-Up 8 ft Heaters", price: "$120/heater"},
  {title: "Ballroom Lounge Setup", price: "$800"},
  {title: "Additional Bartender", price: "$200"},
  {title: "Parking Attendant", price: "$500"},
  {title: "Additional Event Time", price: "$1,250 / half hr"},
  {title: "Additional Setup Time", price: "$250 / hr"},
  {title: "Additional Customized Furniture", price: "Prices Vary"},
];

return (
  <Section id="enhancements" bg="bg-vintage-white">
    <SectionHeader title="Enhancements & Add-Ons" subtitle="Optional details to elevate your celebration." />
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 max-w-5xl mx-auto">
      {enhancements.map((item,idx)=> (
        <div key={idx} className="flex items-center justify-between p-4 bg-white border border-warm-stone/20 rounded-xl hover:border-estate-bronze/30 transition-colors group">
          <span className="font-serif text-sm md:text-base text-deep-charcoal group-hover:text-olive-grove transition-colors">{item.title}</span>
          <span className="font-bold text-estate-bronze whitespace-nowrap ml-4">{item.price}</span>
        </div>
      ))}
    </div>
  </Section>
);
};